import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ReferenceLine, ResponsiveContainer, Cell, Tooltip } from 'recharts';

export const fmtMins = (m) => {
  m = Math.max(0, Math.round(m || 0));
  const h = Math.floor(m / 60), mm = m % 60;
  return h ? `${h}h ${mm}m` : `${mm}m`;
};

// Weekly work-hours bars for the current month with the weekly target as a reference line.
export function WorkHoursChart({ weeks = [], targetHours = 0, height = 170 }) {
  const data = weeks.map(w => ({
    label: w.label, hours: +(w.minutes / 60).toFixed(2), minutes: w.minutes, current: w.is_current,
  }));
  const maxHrs = Math.max(targetHours, ...data.map(d => d.hours), 1);
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 14, right: 8, left: -20, bottom: 0 }} barCategoryGap="22%">
        <XAxis dataKey="label" tick={{ fontSize: 10, fill: 'hsl(var(--muted-foreground))' }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fontSize: 10, fill: 'hsl(var(--muted-foreground))' }} axisLine={false} tickLine={false}
          allowDecimals={false} width={28} domain={[0, Math.ceil(maxHrs + 1)]} />
        <Tooltip cursor={{ fill: 'hsl(var(--secondary))', opacity: 0.4 }}
          contentStyle={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', borderRadius: 6, fontSize: 11 }}
          labelStyle={{ color: 'hsl(var(--foreground))' }}
          formatter={(v, n, p) => [fmtMins(p.payload.minutes), 'Gearbeitet']} />
        {targetHours > 0 && (
          <ReferenceLine y={targetHours} stroke="#f59e0b" strokeDasharray="4 3"
            label={{ value: `Ziel ${targetHours}h`, position: 'right', fill: '#f59e0b', fontSize: 9 }} />
        )}
        <Bar dataKey="hours" radius={[3, 3, 0, 0]} isAnimationActive={false}>
          {data.map((d, i) => (
            <Cell key={i} fill={d.current ? '#38bdf8' : (targetHours > 0 && d.hours >= targetHours ? '#10b981' : '#64748b')} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
